export default "<div class=\"header\">\r\n  <img src=\"../../../../assets/images/bloom.gif\">\r\n</div>\r\n"